<div *ngIf="showBanner" class="banner" id="cookiebanner">
  <p>
    For continuous improvement of user experience this website uses  cookies for collecting your IP address and individual statistics.
    See our <a routerLink="/dataprivacy">data protection guideline</a> for further information and opt-out.
    By clicking OK you agree to share your data. 
  </p>

  <!--button (click)="agreeToShare()">OK</button-->
  <button onclick="gaOptIn()">Agree</button>
</div>